let Brandfocus_data1 =[
    {
        id : 32,
        imgurl : 'img/section5/section5_1_1.jpg'
    },
    {
        id : 33,
        imgurl : 'img/section5/section5_1_2.jpg'
    }
]

export default Brandfocus_data1;